<template>
    <div class="text-center">
        <v-bottom-sheet persistent v-model="sheetShown" inset scrollable>
            <!-- >>> Card: FormFields -------------------------------------- -->
            <v-card>
                <v-card-text class="mt-6" style="height:800px;">
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-container>
                            <v-stepper v-model="formStepper" non-linear>
                                <v-stepper-header>
                                    <v-stepper-step
                                        editable
                                        step="1"
                                        :rules="[ () => isValid_Stepper1 ]"
                                        @click="() => onClick_StepperHeader('1')">
                                        <div>General Vacations: <span style="font-size: 0.8rem; font-weight: 500;">{{ editorMode !== null ? editorMode.toUpperCase() : '' }} ({{ createMode !== null ? createMode.toUpperCase() : '' }})</span></div>
                                    </v-stepper-step>
                                </v-stepper-header>

                                <v-stepper-content step="1" ref="stepperContent1" style="padding-bottom: 0px;">
                                    <!-- >>> Row - Vacation Details -------- -->
                                    <v-row class="input-row">
                                        <v-col cols="12" sm="4">
                                            <h2>Vacations Details:</h2>
                                        </v-col>

                                        <v-col cols="12" sm="8">
                                            <!-- >>> Row - 1, Date --------- -->
                                            <v-row style="margin-left:0px; margin-right:10px; padding: 5px; border-style: solid; border-width: thin; border-color: #d6d6d6;" v-if="selectedDates.length === 0">
                                                <v-col cols="12" sm="6" style="padding: 6px;">
                                                    <v-menu
                                                        ref="dateFromMenu"
                                                        v-model="dateFromMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="formattedDateFrom"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                prepend-icon="mdi-calendar"
                                                                clearable
                                                                :rules ="[
                                                                    rules.req(formattedDateFrom),
                                                                    rules.isBeforeToDate(formattedDateTo, formattedDateFrom)
                                                                ]"
                                                                ref="ref_DateFrom">
                                                                <template v-slot:label>
                                                                    Date From <span style="color: red; font-size: 1.4rem;">*</span>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            ref="picker_DateFrom"
                                                            v-model="input_DateFrom"
                                                            first-day-of-week="1"
                                                            min="2016-01-01"
                                                            max="2025-12-31"
                                                            @change="onChange_SaveDateFrom">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="12" sm="6" style="padding: 6px;">
                                                    <v-menu
                                                        ref="dateToMenu"
                                                        v-model="dateToMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="formattedDateTo"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                prepend-icon="mdi-calendar"
                                                                clearable
                                                                :rules ="[
                                                                    rules.req(formattedDateTo),
                                                                    rules.isAfterStartDate(formattedDateFrom, formattedDateTo)
                                                                ]"
                                                                ref="ref_DateTo">
                                                                <template v-slot:label>
                                                                    Date To <span style="color: red; font-size: 1.4rem;">*</span>
                                                                </template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            ref="picker_DateTo"
                                                            v-model="input_DateTo"
                                                            first-day-of-week="1"
                                                            min="2016-01-01"
                                                            max="2025-12-31"
                                                            @change="onChange_SaveDateTo">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                            <v-row style="margin-left:0px; margin-right:10px; padding: 5px; border-style: solid; border-width: thin; border-color: #d6d6d6;" v-if="selectedDates.length > 0">
                                                <p style="font-size: 1.0rem; font-weight: 600; margin: 0; display: inline;" v-for="(date, index) in selectedDates" :key="date.date">
                                                    {{ formateDate(date.date) }}{{ index !== selectedDates.length - 1 ? ";&nbsp;&nbsp;" : " " }}
                                                </p>
                                            </v-row>


                                            <!-- >>> Row - 2, Type --------- -->
                                            <v-row style="margin-top: 15px;">
                                                <v-col cols="12" sm="4">
                                                    <v-select
                                                        v-model="input_DateType"
                                                        :items="items_DateType"
                                                        item-text="text"
                                                        item-value="value"
                                                        label="Dates Type"
                                                        prepend-icon="mdi-chevron-down-circle"
                                                        :disabled="editorMode === 'update'">
                                                    </v-select>
                                                </v-col>
                                            </v-row>


                                            <!-- >>> Row - 3.1 ------------- -->
                                            <v-row v-if="input_DateType === 'DAYOFF'">
                                                <v-col cols="12" sm="4">
                                                    <v-checkbox
                                                        v-model="input_Requested"
                                                        label="Requested">
                                                    </v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="4">
                                                    <v-checkbox
                                                        v-model="input_FromLastYear"
                                                        label="From last year">
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>


                                            <!-- >>> Row - 3.2 ------------- -->
                                            <v-row v-if="input_DateType === 'VACATION'">
                                                <v-col cols="12" sm="4">
                                                    <v-combobox
                                                        v-model="input_Requeststatus"
                                                        :items="options"
                                                        label="Request Status"
                                                        prepend-icon="mdi-chevron-down-circle"
                                                        clearable
                                                        chips>
                                                    </v-combobox>
                                                </v-col>
                                            </v-row>


                                            <!-- >>> Row - 4, Comment ------ -->
                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-textarea
                                                        v-model="input_Comment"
                                                        name="input_Comment"
                                                        label="Comment"
                                                        auto-grow
                                                        maxlength="200"
                                                        prepend-icon="mdi-comment"
                                                        counter
                                                        filled
                                                        clearable
                                                        rows="2"
                                                        value="">
                                                    </v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <<< Row - Vacation Details -------- -->
                                </v-stepper-content>

                                <p v-html="explanation" style="margin-left:20px; margin-right:20px; padding: 10px; border-style: solid; border-color: #ab3b7a;"></p>
                            </v-stepper>
                        </v-container>
                    </v-form>
                </v-card-text>


                <!-- >>> Action Buttons - Bottom --------------------------- -->
                <v-card-actions>
                    <p class="mb-0 ml-7 font-weight-medium">Current Resource: {{ get_FullMemberName }}</p>
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet"> Close</v-btn>
                    <v-btn style="width:120px" depressed elevation="1" color="primary" @click="onValidate_Form"> Save</v-btn>
                </v-card-actions>
                <!-- <<< Action Buttons - Bottom --------------------------- -->
            </v-card>
            <!-- <<< Card: FormFields -------------------------------------- -->
        </v-bottom-sheet>
    </div>
</template>


<script>
    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main';

    import dayjs from "dayjs";
    dayjs.extend(customParseFormat);
    import customParseFormat from "dayjs/plugin/customParseFormat";


    export default {
        name: 'BottomSheet',

        /* >>> *************************************************************** / /* Props */
        props: {

            value : [Boolean], // 'showSheet'
            editorMode : String, // 'update', 'create'
            createMode : String, // 'multibreaks', 'singlebreaks'
            selectedDates : Array,
            resourcePrefillObject : Array // item

		}, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
		data: function() {

			return {
                // >>> ------------------------------------
                explanation : '<h4>Urlaubsregelung Erläuterungen</h4>Jeder Mitarbeiter hat eine durchschnittliche 5-Tage Woche (siehe Anlage 1, Auszug AV §14(1)). Bis zum 15.10. des Vorjahres müssen 90% des Jahresurlaubs in maximal 2 großen Blöcken beantragt sein. Die verbleibenden Urlaubstage dürfen im laufenden Jahr, jedoch spätestens bis zum 10. des Vormonats, beantragt werden. Urlaubstage und OFF-Tage können zusammenhängend angefragt werden, einen Anspruch auf die Genehmigung gibt es nicht (Anlage 1). Der beantragte Urlaub wird nach Berücksichtigung betrieblicher Erfordernisse von Sundair geprüft und gewährt (§14 (5)).<br /><h4>Beispiel: </h4>5 Urlaubstage werden von 2 OFF-Tagen umschlossen ( 1 Tag davor + 1 Tag danach) 10 Urlaubstage werden von 4 Off-Tagen umschlossen (2Tage davor + 2 Tage danach)<br /><h4>Sommerferien:</h4> Maximal 2 Wochen am Stück.<br /><h4>Weihnachten und Silvester:</h4> Urlaub kann entweder über Weihnachten oder Silvester genommen werden.',
                // >>> ------------------------------------ 'Form Validation Rules'
                valid : true,
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || `Field is required`;
                    },
                    // need to add one second, because the calender picker sets dates to time 00:00:00
                    // isSame returns false for the same days (with the same time), but the input should
                    // be valid
                    isAfterStartDate(start, v) {
                        return v === "" || start === "" || dayjs(v, "DD.MM.YYYY").add(1, "second").isAfter(dayjs(start, "DD.MM.YYYY")) || 'Date To could not be before Date From';
                    },
                    isBeforeToDate(to, v) {
                        return v === "" || to === "" || dayjs(v, "DD.MM.YYYY").subtract(1, "second").isBefore(dayjs(to, "DD.MM.YYYY")) || 'From Date could not be after To Date';
                    }
                },
                // >>> ------------------------------------
                formStepper: 1,
                // >>> ------------------------------------
                input_DateType: 'VACATION',
                items_DateType: [{ text: 'Vacation', value: 'VACATION' }, { text: 'Offday', value: 'DAYOFF' }, { text: 'Unable to fly', value: 'UNABLEFLIGHT' }],
                input_DateFrom: null,
                input_DateTo: null,
                input_Requested: false,
                input_FromLastYear: false,
                input_Comment: "",
                input_Requeststatus: null,
                options: [
                    'REQUESTED',
                    'MAINREQUEST',
                    'SECONDARYREQUEST',
                    'REPLACEMENTREQUEST',
                    'APPROVED',
                    'REFUSED',
                ],
                // >>> ------------------------------------
                isValid_Stepper1: true,
                activeStepper: '1',
                // >>> ------------------------------------
                dateFromMenu: null,
                dateToMenu: null,
                // >>> ------------------------------------
                doNotRerender: false,
            };

        }, // eo data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_FullMemberName',
                'get_idResource',
                'get_selectedYear',
                'getIdGroup',
                'get_shared_IsDutyAccessAllowed',
            ]),


            /*******************************************************************
            * sheetShown{}
            *
            * Desc:
            * Note:
            *
            */
            sheetShown: {

                get() {

                    const me = this,
                        eventRecord = me.resourcePrefillObject;


                    me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> computed/sheetShown/get');
                    if (true === me.value && me.doNotRerender === false) { // we're opening so initialize data

                        // >>> ------------------ reset validation
                        if (this.$refs.form !== undefined) {
                            this.$refs.form.resetValidation();
                        }

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                this.onAssign_Update(eventRecord);
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            this.onAssign_Create(eventRecord);
                        }

                    }


                    return this.value;

                }, // eo function sheetShown get()

                set(value) {

                    let  me = this;


                    me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> computed/sheetShown/set');
                    me.$emit('input', value);

                }, // eo function sheetShown set()

            }, // eo sheetShown{}


            /*******************************************************************
			* formattedDateFrom{}
			*
			* Desc:
			* Note:
			*
			*/
            formattedDateFrom: {

                get() {

                    const me = this;


                    me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> computed/formattedDateFrom/get');
                    return this.input_DateFrom ? this.formatDateForTextField(this.input_DateFrom) : '';

                }, // eo function formattedDateFrom get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> computed/formattedDateFrom/set');
                    return this.input_DateFrom = value;

                }, // eo function formattedDateFrom set()

            }, // eo function formattedDateFrom()


            /*******************************************************************
			* formattedDateTo{}
			*
			* Desc:
			* Note:
			*
			*/
            formattedDateTo: {

                get() {

                    const me = this;


                    me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> computed/formattedDateTo/get');
                    return this.input_DateTo ? this.formatDateForTextField(this.input_DateTo) : '';

                }, // eo function formattedDateTo get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> computed/formattedDateTo/set');
                    return this.input_DateTo = value;

                }, // eo function formattedDateTo set()

            }, // eo function formattedDateTo()

        }, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
			* dateFromMenu()
			*
			* Desc:
			* Note:
			*
			*/
            dateFromMenu: function (val) {

                val && setTimeout(() => (this.$refs.picker_DateFrom.activePicker = 'YEAR'));

            }, // eo function dateFromMenu()


            /*******************************************************************
			* dateToMenu()
			*
			* Desc:
			* Note:
			*
			*/
            dateToMenu: function (val) {

                val && setTimeout(() => {
                    this.$refs.picker_DateTo.activePicker = 'YEAR';
                });

            }, // eo function dateToMenu()


            /*******************************************************************
			* input_DateType()
			*
			* Desc:
			* Note:
			*
			*/
            input_DateType: function() {

                const me = this;


                me.input_Requested = false;
                me.input_FromLastYear = false;
                me.doNotRerender = true;

            } // eo function input_DateType()

        }, // eo watch{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Special settings for 'member/admin' mode.
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> created');
            eventBus.$on('vacationsCreated', this.onClick_CloseSheet);

            if (me.get_shared_IsDutyAccessAllowed !== true) {
                this.items_DateType = [{ text: 'Vacation', value: 'VACATION' }, { text: 'Offday', value: 'DAYOFF' }]; // #632
                this.options = [
                    'MAINREQUEST',
                    'SECONDARYREQUEST',
                    'REPLACEMENTREQUEST',
                ];
            }

		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> destroyed');
            eventBus.$off('vacationsCreated', me.onClick_CloseSheet);

		}, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
		methods: {

            ...mapActions([
                'actn_call_createSingleVacations',
                'actn_call_createMultiVacations',
            ]),


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate_Form()
            *
            * Desc: Check if Form is valid.
            * Note: used in 'update' and 'create' Mode.
            * Note: Sends 'id' in 'update' Mode...And NO 'id' in 'create' Mode.
            *
            */
            onValidate_Form: function() {

                const me = this;
                let payload = null;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> onValidate_Form');
                // me.validateFormStepper("1");

                if (this.$refs.form.validate() === true) {

                    // >>> Create (singlebreaks) -------------------------------
                    if (this.createMode === 'singlebreaks') {
                        payload = {
                            id: null, // Important: Watch this!,
                            dutyComment: me.input_Comment !== '' ? me.input_Comment : null,
                            from: dayjs(me.input_DateFrom).format("YYYY-MM-DDT05:00:00+0000"),
                            idResource: me.get_idResource,
                            split: true,
                            status: "PLANNED",
                            to: dayjs(me.input_DateTo).format("YYYY-MM-DDT21:00:00+0000"),
                            type: me.input_DateType,
                            requestStatus: me.input_Requeststatus !== null ? me.input_Requeststatus.toUpperCase() : null,
                        }

                        if (me.input_DateType === "DAYOFF") {
                            Object.assign(payload, {
                                idResources: [me.get_idResource],
                                activated: false,
                                remainingDayoff: me.input_FromLastYear,
                                requested: me.input_Requested
                            });
                        }

                        me.actn_call_createSingleVacations({ payload: payload, editorMode: me.editorMode });
                    }
                    // <<< Create (singlebreaks) -------------------------------


                    // >>> Create/Update (multibreaks) -------------------------
                    if (this.createMode === 'multibreaks') {
                        if (me.input_DateType  === "VACATION") {
                            me.actn_call_createMultiVacations({ payload: me.build_CreateMutipleVacationsPayload(me.selectedDates), editorMode: me.editorMode });
                        }
                        if (me.input_DateType  === "DAYOFF") {
                            me.actn_call_createMultiVacations({ payload: me.build_CreateMutipleDayoffPayload(me.selectedDates), editorMode: me.editorMode });
                        }
                        if (me.input_DateType  === "UNABLEFLIGHT") {
                            me.actn_call_createMultiVacations({ payload: me.build_CreateMutipleUnablePayload(me.selectedDates), editorMode: me.editorMode });
                        }
                    }
                    // <<< Create (multibreaks) --------------------------------

                }

            }, // eo function onValidate_Form()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            *
            */
			onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> onClick_CloseSheet');
                me.doNotRerender = false;
				me.sheetShown = false;

                me.input_Requeststatus = null; // reset

            }, // eo function onClick_CloseSheet()


            /*******************************************************************
			* onChange_SaveDateFrom()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SaveDateFrom: function(date) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> onChange_SaveDateFrom');
                me.$refs.dateFromMenu.save(date);

            }, // eo function onChange_SaveDateFrom()


            /*******************************************************************
			* onChange_SaveDateTo()
			*
			* Desc:
            * Note:
            *
            * @param {Object} date ()
			*/
			onChange_SaveDateTo: function(date) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> onChange_SaveDateTo');
                this.$refs.dateToMenu.save(date);

            }, // eo function onChange_SaveDateTo()


            /*******************************************************************
            * validateFormStepper()
            *
            * Desc: Validate a single Steppers inputs.
            * Note: Get all children of a Stepper with a ref.
            * Note: Loop over the children and identify them as input fields,
            * Note: after that check for the VALID key.
            *
            * @param {Number} stepperNumber
            * @returns {Boolean}
            */
            validateFormStepper: function(stepperNumber) {

                const me = this,
                    stepperIsValid = true,
                    child = null,
                    childInputIsValid = null,
                    stepperRef = null;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> validateFormStepper');
                switch (stepperNumber) {
                    case "1":
                        stepperRef = this.$refs.stepperContent1;
                        break;
                    default:
                        stepperRef = null;
                        break;
                }


                if (stepperRef !== null) {
                    for (let i = 0; i < stepperRef.$children.length; i++) {
                        child = stepperRef.$children[i];

                        childInputIsValid = this.findInputField(child);

                        if (childInputIsValid !== null && childInputIsValid.valid === false) {
                            stepperIsValid = false;
                            break;
                        }
                    }
                }


                switch (stepperNumber) {
                    case "1":
                        this.isValid_Stepper1 = stepperIsValid;
                        break;
                    default:
                        break;
                }


                return stepperIsValid;

            }, // eo function validateFormStepper()


            /*******************************************************************
            * findInputField()
            *
            * Desc: Identify an element as INPUT.
            * Note: Check ELEMENT of being an input field.
            * Note: It is an input field if the key "type" exists in this
            * Note: object. ('type' in element)
            * Note: If this object does not have this "type" key, look up
            * Note: the children of this ELEMENT recursivly.
            *
            * @param {Object} element
            * @returns {Object | null}
            */
            findInputField: function(element) {

                const me = this,
                    inputField = null;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> findInputField');
                if ('type' in element) { // ;-)
                    inputField = element;
                } else {
                    if (element.$children.length > 0) {
                        inputField = this.findInputField(element.$children[0])
                    }
                }


                return inputField;

            }, // eo function findInputField()


            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc: Validate leaved Stepper Content, set new active Stepper.
            * Note: First validate the activeStepper, but only if it was
            * Note: validated as FALSE before.
            *
            */
            onClick_StepperHeader: function(stepperNumber) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> onClick_StepperHeader');
                switch (me.activeStepper) {
                    case '1':
                        if (me.isValid_Stepper1 === false) {
                            me.validateFormStepper('1');
                        }
                        break;
                    default: break;
                }

                me.activeStepper = stepperNumber;

            }, // eo function onClick_StepperHeader()




            /*******************************************************************
            * Utilities/Helper:
            *******************************************************************/
            /******************************************************************* 'Assign -  Update/Create'
            * onAssign_Create()
            *
            * Desc: Assign Object in/for 'create' Mode. (Reset)
            * Note:
            *
            * @param {Object} eventRecord ()
            */
            onAssign_Create: function(eventRecord) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> onAssign_Create');
                Object.assign(me, {
                    input_DateType: "VACATION",
                    input_DateFrom: null,
                    input_DateTo: null,
                    input_Comment: "",
                    // >>> ------------------------------------ 'Stepper Errors'
                    isValid_Stepper1: true,
                    activeStepper: '1',
                });

            }, // eo function onAssign_Create()


            /*******************************************************************
            * onAssign_Update()
            *
            * Desc: Assign Object in/for 'update' Mode.
            * Note:
            *
            * @param {Object} eventRecords ()
            */
            onAssign_Update: function(eventRecords) {

                const me = this;
                let commentsConcenated = '';


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> onAssign_Update');
                eventRecords.forEach(item => {
                    commentsConcenated += item.comment !== null ? item.comment + '\n' : '';
                });

                Object.assign(me, {
                    input_DateType: eventRecords[0].type,
                    input_DateFrom: null,
                    input_DateTo: null,
                    input_Comment: commentsConcenated, // eventRecords[0].comment,
                    // >>> ------------------------------------ 'Stepper Errors'
                    isValid_Stepper1: true,
                    activeStepper: '1',
                });

            }, // eo function onAssign_Update()




            /*******************************************************************
            * formatDateForTextField()
            *
            * Desc: Modify the date with the utc filter.
            *
            * @param {Object} date ()
            */
            formatDateForTextField: function(date) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> formatDateForTextField');
                return me.$options.filters.dayjsUtcDe(date);

            }, // eo function formatDateForTextField()


            /*******************************************************************
            * formateDate()
            *
            * Desc:
            * Note:
            *
            */
            formateDate: function(date) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> formatDatformateDateeForTextField');
                return dayjs(date).format("D.MMMM YYYY")

            }, // eo funtion formateDate()




            /*******************************************************************
            * build_CreateMutipleVacationsPayload()
            *
            * Desc:
            * Note: Sends 'ids' if we are in editorMode 'update'.
            *
            */
            build_CreateMutipleVacationsPayload: function(selectedDates) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> build_CreateMutipleVacationsPayload');
                return {
                    breaks: selectedDates.map(d => {
                        return {
                            dutyComment: me.input_Comment !== '' ? me.input_Comment : null,
                            from: dayjs(d.date, "YYYY-MM-DD").format("YYYY-MM-DD[T]05:00:00+0000"),
                            id: me.editorMode === 'update' ? d.id : null, // update:create
                            idResource: me.get_idResource,
                            split: true,
                            status: "PLANNED",
                            to: dayjs(d.date, "YYYY-MM-DD").format("YYYY-MM-DD[T]21:00:00+0000"),
                            type: "VACATION",
                            requestStatus: me.input_Requeststatus !== null ? me.input_Requeststatus.toUpperCase() : null,
                        }
                    })
                }

            }, // eo function build_CreateMutipleVacationsPayload()


            /*******************************************************************
            * build_CreateMutipleUnablePayload()
            *
            * Desc:
            * Note: Sends 'ids' if we are in editorMode 'update'.
            *
            */
            build_CreateMutipleUnablePayload: function(selectedDates) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> build_CreateMutipleUnablePayload');
                return {
                    breaks: selectedDates.map(d => {
                        return {
                            dutyComment: me.input_Comment !== '' ? me.input_Comment : null,
                            from: dayjs(d.date, "YYYY-MM-DD").format("YYYY-MM-DD[T]05:00:00+0000"),
                            id: me.editorMode === 'update' ? d.id : null, // update:create
                            idResource: me.get_idResource,
                            split: true,
                            status: "PLANNED",
                            to: dayjs(d.date, "YYYY-MM-DD").format("YYYY-MM-DD[T]21:00:00+0000"),
                            type: "UNABLEFLIGHT",
                            requestStatus: me.input_Requeststatus !== null ? me.input_Requeststatus.toUpperCase() : null,
                        }
                    })
                }

            }, // eo function build_CreateMutipleUnablePayload()


            /*******************************************************************
            * build_CreateMutipleDayoffPayload()
            *
            * Desc:
            * Note: Sends 'ids' if we are in editorMode 'update'.
            *
            */
            build_CreateMutipleDayoffPayload: function(selectedDates) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/components/core/BottomSheet.vue >>> build_CreateMutipleDayoffPayload');
                return {
                    breaks: selectedDates.map(d => {
                        return {
                            dutyComment: me.input_Comment !== '' ? me.input_Comment : null,
                            from: dayjs(d.date, "YYYY-MM-DD").format("YYYY-MM-DD[T]05:00:00+0000"),
                            id: me.editorMode === 'update' ? d.id : null, // update:create
                            idResource: me.get_idResource,
                            split: true,
                            status: "PLANNED",
                            to: dayjs(d.date, "YYYY-MM-DD").format("YYYY-MM-DD[T]21:00:00+0000"),
                            type: "DAYOFF",
                            idResources: [me.get_idResource],
                            activated: false,
                            remainingDayoff: me.input_FromLastYear,
                            requested: me.input_Requested,
                            requestStatus: me.input_Requeststatus !== null ? me.input_Requeststatus.toUpperCase() : null,
                        }
                    })
                }

            }, // eo function build_CreateMutipleDayoffPayload()

        } // eo methods{}
		/* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-dialog > .v-card > .v-card__actions {
        padding: 10px 10px;
    }

    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        max-height:700px;
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }
</style>